import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ResponseTypes } from "src/models/app-enums.model";
import { Instrument, Section } from "src/models/question.model";
import { QuestionnaireResponseQuestion } from "src/models/questionnaire-response.model";

/**
 * Service which manages the state for launch creation
 * information, so it can be displayed
 */
@Injectable({
    providedIn: 'root'
})
export class QuestionsService implements OnDestroy {

    private _instrument!: Instrument
    private _allQuestions!: QuestionnaireResponseQuestion[]
    private _questionsInCurrentSection!: QuestionnaireResponseQuestion[]
    private _sectionSubject = new BehaviorSubject<Section | undefined>(undefined)
    private _sectionIndex: number = 0

    set instrument(instrument: Instrument) {
        this._instrument = instrument
        this.section = this._instrument.section[0]
    }

    set allQuestions(allQuestions: QuestionnaireResponseQuestion[]) {
        this._allQuestions = allQuestions
        this._questionsInCurrentSection = this._getQuestionsInCurrentSectionSorted()
    }

    get allQuestions(): QuestionnaireResponseQuestion[] {
        return this._allQuestions
    }
    
    get section$(): Observable<Section | undefined> {
        return this._sectionSubject.asObservable()
    }

    set section(section: Section) {
        this._sectionSubject.next(section)
        if(this._allQuestions) {
            this._questionsInCurrentSection = this._getQuestionsInCurrentSectionSorted()
        }
    }

    get section(): Section | undefined {
        return this._sectionSubject.getValue()
    }

    get questionsInCurrentSection(): QuestionnaireResponseQuestion[] {
        return this._questionsInCurrentSection
    }

    get sections() :Section[] {
        return this._instrument.section
    }

    get lastSection(): Section {
        return this._instrument.section[this._instrument.section.length - 1]
    }

    /**
     * 
     * @returns 
     */
    nextSection() {
        if( this._instrument.section.length - 1 === this._sectionIndex){ return false }
        this.section = this._instrument.section[++this._sectionIndex]
        return true
    }

    /**
     * 
     * @returns 
     */
    previousSection() {
        if( this._sectionIndex === 0){ return false }
        this.section = this._instrument.section[--this._sectionIndex]
        return true
    }

    /**
     * 
     * @returns 
     */
    private _getQuestionsInCurrentSectionSorted(): QuestionnaireResponseQuestion[] {
        return this._allQuestions
            // filter to questions in the current section
            .filter(q => q.surveySection === this.section?.sectionName && q.responseType !== ResponseTypes.TermsAndConditions)
            // sort in ascending order
            .sort((q1, q2) => q1.sequenceNumber - q2.sequenceNumber)
    }
    
    /**
     * 
     */
    ngOnDestroy(): void {
        this._sectionSubject.complete()
    }
}